import { showRewardPopup, type RewardPopupDetail } from './reward_event';

//Dynamite,Funky, Far Out, Spectacular,Radiant, Slick,Stellar,Epic ,Radical,Choice,Phenomenal
const REWARD_POPUPS: Record<string, RewardPopupDetail> = {
  frisbee_reward: {
    title: 'You unlocked Frisbee!',
    rewardImageUrl: '/api/resource/reward_frisbee.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Awesome!',
  },
  bone_reward: {
    title: 'You earned 7 Bones!',
    rewardImageUrl: '/api/resource/reward_bones.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Nice!',
  },
  picnic_blanket_reward: {
    title: 'You earned a Picnic Blanket!',
    rewardImageUrl: '/api/resource/reward_picnic_blanket.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Groovy!',
  },
   swing_reward: {
    title: 'You earned a Tire Swing!',
    rewardImageUrl: '/api/resource/reward_swing.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Funky!',
  },
  hidenseek_reward: {
    title: 'You unlocked Hide and Seek!',
    rewardImageUrl: '/api/resource/reward_hidenseek.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Spectacular!',
  },
  pool_reward: {
    title: 'You earned a Swimming Pool!',
    rewardImageUrl: '/api/resource/reward_pool.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Epic!',
  },
  brush_reward: {
    title: 'You earned a Bath Brush!',
    rewardImageUrl: '/api/resource/reward_bath_brush.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Choice!',
  },
  bathtub_reward: {
    title: 'You earned a Bathtub!',
    rewardImageUrl: '/api/resource/reward_bathtub.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Radical!',
  },
  walk_reward: {
    title: 'You unlocked Walk the Dog!',
    rewardImageUrl: '/api/resource/reward_walk.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Phenomenal!',
  },
  bed_reward: {
    title: 'You earned a Bed!',
    rewardImageUrl: '/api/resource/reward_bed.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Slick!',
  },
  fence_reward: {
    title: 'You earned a Fence!',
    rewardImageUrl: '/api/resource/reward_fence.png',
    frameImageUrl: '/api/resource/reward_frame.png',
    buttonLabel: 'Far Out!',
  },

};

export default class RewardManager
{

    rewards:string[];
    reward_index:number = 0;
    constructor()
    {

        this.rewards =["frisbee_reward","picnic_blanket_reward",
            "swing_reward","hidenseek_reward", 
            "pool_reward","brush_reward","bathtub_reward",
            "walk_reward","bed_reward","fence_reward"
        ];
    }

    show_next(msg:string):string | null
    {
          if(msg == "bones")
          {
            const reward = REWARD_POPUPS["bone_reward"];
             showRewardPopup(reward);
          }
          else
          {
            //next
                const key = this.rewards[this.reward_index];
                const reward = REWARD_POPUPS[key];
                this.reward_index ++;
                if(this.reward_index == this.rewards.length) 
                {
                    this.reward_index = 0;
                }
                showRewardPopup(reward);
                if(key =="frisbee_reward" ) return "frisbee";
                else if(key =="swing_reward" ) return "tire_swing";
                else if(key == "walk_reward") return "walk_dog";
                else if(key == "hidenseek_reward") return"hide_n_seek";
            }
            return null;
    }
}